export default __webpack_public_path__ + "static/media/ms-teams.78c12bde.png";